<script>
export default {
    name: "navigation-header",
    data: function () {
        return {
            'dropdown': false,
            'mobile': false,
        }

    },
    methods:{

    },
    mounted() {
    document.addEventListener('click', event => {
        event.stopPropagation();
        if(!this.$refs.mmm.contains(event.target)) {
            this.dropdown = false;
        }
    });
}

}
</script>

